// extracted by mini-css-extract-plugin
export default {"container":"Comments_container__YW9PD","comment":"Comments_comment__Kws94","date":"Comments_date__vM16e","notPaidContainer":"Comments_notPaidContainer__q22tB"};